import togglePoint from "/app/src/universal/components/containers/withTogglePoint/index.js";
import handler from "@asosteam/asos-web-toggle-point-webpack/pathSegmentToggleHandler";
export default (rest) => handler({ togglePoint, ...rest });